import Helmet from 'react-helmet';
import type { ReactNode, VoidFunctionComponent } from 'react';

import { PolicyType } from '../../../typings/enums';
import Loader from '../generic/Loader';
import type { AsyncStatus } from '../../types';

type ListSbomPoliciesPageProps = {
  renderPolicyList: (policyType: PolicyType) => ReactNode;
  status: AsyncStatus,
};

const ListSbomPoliciesPage: VoidFunctionComponent<ListSbomPoliciesPageProps> = ({
  renderPolicyList,
  status,
}) => {
  return (
    <div className="container margin-top">
      <Helmet title="Policies" />
      {status?.errors?.map(error => <div className="alert alert-error">{error}</div>)}
      {status?.loading ? <Loader /> : renderPolicyList(PolicyType.SBOM)}
    </div>
  );
};

export default ListSbomPoliciesPage;
